export enum AccordionItemIconsEnum {
    Plus = 'plus',
    Check = 'check',
    Info = 'information',
}
